import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './styles.css';
import image1 from './display5.jpg';
import image2 from './Wedding2.jpg';
import image3 from './cover4.jpg';
import image7 from './lobola1.jpeg';
import image8 from './Wedding30.jpeg';
import image9 from './cover5.jpg';

const slideImages = [image7, image8, image2, image3, image1, image9];

export const Slidehsow = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveSlide((current) => (current + 1) % slideImages.length);
    }, 6500);

    return () => window.clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => setActiveSlide(index);

  return (
    <section className="hero" aria-label="Rue's Events featured work">
      <div className="hero-slides" aria-hidden="true">
        {slideImages.map((image, index) => (
          <img
            key={image}
            src={image}
            alt=""
            className={`hero-image${index === activeSlide ? ' hero-image--active' : ''}`}
          />
        ))}
      </div>

      <div className="hero-shade" />

      <div className="hero-content section-shell">
        <p className="hero-eyebrow">We plan. We design. We deliver.</p>
        <h1>
          Creating memorable events,
          <span> beautifully brought to life.</span>
        </h1>
        <p className="hero-copy">
          From weddings and lobola celebrations to corporate events, birthdays and florals,
          Rue's Events Designs turns your vision into an experience your guests will remember.
        </p>
        <div className="hero-actions">
          <Link to="/contact" className="rue-button">Plan Your Event</Link>
          <Link to="/gallery" className="rue-button rue-button--secondary">View Our Work</Link>
        </div>
      </div>

      <div className="hero-dots" aria-label="Choose featured image">
        {slideImages.map((_, index) => (
          <button
            key={index}
            type="button"
            className={index === activeSlide ? 'hero-dot hero-dot--active' : 'hero-dot'}
            onClick={() => goToSlide(index)}
            aria-label={`Show image ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};
